// local imports
import { ReactComponent as Lactation } from 'assets/icons/baby.svg'
import useGetLactationServiceChartData from './hooks/use-get-lactation-service-data'
import DoughnutChartPage from '../../chart-molecules/DoughnutPage/DoughnutChartPage'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'
import LactationServiceDist from 'components/dashboard/chart-templates/chartcardpage/tabs/LactationDist'

export default function LactationServiceCharts(props: {
  userInfo: any
  firmList: any
  startDate: Date
  endDate: Date
  selectedFirms: any
}) {
  const { t, excelData, items, labels, colors, detailTitle, footerTitle } = useGetLactationServiceChartData(props)
  const translatedLabels = labels.map((label) => t(label))

  return (
    <LactationServiceDist excelData={excelData}>
      <div className="row">
        {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
          <div className="col-3 d-flex justify-content-between flex-column">
            <div className="mt-5">
              <DoughnutChartPage
                icon={<Lactation width={24} height={24} />}
                items={undefined}
                colors={colors}
                labels={translatedLabels}
                detailTitle={t(detailTitle)}
                totalNotification={items?.doughnutItems.total}
              />
            </div>

            <div>
              <span style={{ fontSize: '14px' }}>{t(footerTitle)}</span>
            </div>
          </div>
        )}

        <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9 ' : 'col-12'}>
          <StackedChart
            chartId="healthChart"
            tabIndex={5}
            colors={colors}
            labels={translatedLabels}
            checkedValue=""
            setCheckedValue=""
            response={items}
            userInfo={props.userInfo}
            tooltipLabel={t('dashboard.on-campus-tabs.tooltipMsg')}
          />
        </div>
      </div>
    </LactationServiceDist>
  )
}
